import { Component, OnInit, Renderer2, OnDestroy, AfterViewInit, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Validators } from "@angular/forms";
import { AuthService } from "../../service/auth-service/auth.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { sweetAlert } from "../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";


@Component({
  selector: "two-factor-authentication",
  templateUrl: "./two-factor-authentication.component.html",
  styleUrls: ["./two-factor-authentication.component.css"],
})
export class TwoFactorAuthenticationComponent implements OnInit, OnDestroy, AfterViewInit {
  success: boolean;
  sendMfaFormGroup: FormGroup;
  verifyMfaFormGroup: FormGroup;
  isSubmitted = false;
  isVerifySubmitted = false;
  isReSend = false;
  isVerifyShow = false;
  mfaToken: string= ''

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.sendMfaFormGroup = this.fb.group({
      method: ["", [Validators.required]]
    });

    this.verifyMfaFormGroup = this.fb.group({
      code: ["", [Validators.required]]
    });


    this.authService.mfa$.subscribe(value => {
      console.log("Received MFA token:", value);
      this.mfaToken = value;
    });

  }


  get verifyMfaForm() {
    return this.verifyMfaFormGroup.controls;
  }

  get sendMfaForm() {
    return this.sendMfaFormGroup.controls;
  }

  onReSendCode() {
    this.isVerifyShow = false;
    this.isReSend = true;
    this.isSubmitted = false;
    this.isVerifySubmitted = false;
    this.sendMfaFormGroup.patchValue({
      method: ""
    });

    this.verifyMfaFormGroup.patchValue({
      code: ""
    });

  }

  onSendMfa() {
    this.isSubmitted = true;
    if (this.sendMfaFormGroup.invalid) {
      return;
    }

    this.authService
      .sendMfaCode(this.isReSend, { ...this.sendMfaFormGroup.value, mfaToken: this.mfaToken  })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
          this.isReSend = false;
          this.isVerifyShow = true;

          this.isSubmitted = false;
          this.isVerifySubmitted = false;
          sweetAlert("Success", data.message, "success", "OK");
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

  }

  onBackToLogin() {
    this.router.navigateByUrl('/login');
  }

  onVerifyMfaForm() {
    this.isVerifySubmitted = true;
    if (this.verifyMfaFormGroup.invalid) {
      return;
    }

    this.authService
      .verifyMfaCode( { ...this.verifyMfaFormGroup.value, mfaToken: this.mfaToken  })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
          this.authService.removeMFA();
          this.authService.setToken(data.token);
          this.sharedDataService.saveUser(data.user);
          this.socket.connectSocket();
          this.router.navigateByUrl('/');
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  ngOnDestroy(): void {

  }

  ngAfterViewInit() {

  }
}
